import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, TranslateResolver, UnauthGuard } from '@motivforce/mx-library-angular';

import { LoginContentTemplateComponent } from './components/login-content-template/login-content-template.component';
import { LoginImpersonateContainerComponent } from './components/login-impersonate-container/login-impersonate-container.component';
import { LoginRedirectContainerComponent } from './components/login-redirect-container/login-redirect-container.component';
import { LogoutContainerComponent } from './components/logout-container/logout-container.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login/admin',
    component: LoginContentTemplateComponent,
    canActivate: [UnauthGuard],
  },
  {
    path: 'login',
    data: {
      pageTitle: (data: any) => data.translate.instant('Login'), // translate service not available
    },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    resolve: { translate: TranslateResolver },
    canActivate: [UnauthGuard],
  },
  {
    path: 'logout',
    data: {
      pageTitle: (data: any) => data.translate.instant('Logout'), // translate service not available
    },
    component: LogoutContainerComponent,
    resolve: { translate: TranslateResolver },
    canActivate: [],
  },

  {
    path: 'forgot-password',
    data: {
      pageTitle: (data: any) => data.translate.instant('Forgot Password'), // translate service not available
    },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    resolve: { translate: TranslateResolver },
    canActivate: [UnauthGuard],
  },
  {
    path: 'set-password',
    data: {
      pageTitle: (data: any) => data.translate.instant('Set Password'), // translate service not available
    },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    resolve: { translate: TranslateResolver },
    canActivate: [UnauthGuard],
  },
  {
    path: 'redirect',
    component: LoginRedirectContainerComponent,
    canActivate: [],
    data: {
      hideHeaderFooter: true,
    },
  },
  {
    path: 'impersonate',
    component: LoginImpersonateContainerComponent,
    canActivate: [AuthGuard],
    data: {
      hideHeaderFooter: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
